import { useEffect, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Card, StyledBody } from 'baseui/card';
import { toaster } from 'baseui/toast';
import { getProjectHints, requestMatch } from '@gtintel/platform-api';
import { Button } from '@gtintel/platform-atoms';
import { useAsyncOp } from '@gtintel/platform-utils';
import AskingCarlosSpinner from '../../../components/Buttons/RequestMatch/Loading';
import { useMatching } from '../../context';
import FeedbackButtons from '../FeedbackButtons';
export function MatchingCard({
  title
}) {
  const QUESTION_TYPE = 'mh';
  const [css] = useStyletron();
  const matchCtx = useMatching();
  const {
    fn: getHints
  } = useAsyncOp(getProjectHints);
  const {
    fn: reqMatch
  } = useAsyncOp(requestMatch);
  const [hints, setHints] = useState([]);
  const [activeMatchingHint, setActiveMatchingHint] = useState(0);
  const [isLoadingHints, setIsLoadingHints] = useState(false);
  const [hasRequestedMatch, setHasRequestedMatch] = useState(false);
  const fetchHints = async projectId => {
    let attemptCount = 0;
    while (attemptCount < 5) {
      try {
        const data = await getHints(projectId, QUESTION_TYPE);
        if (data.length > 0) return data;
      } catch (error) {
        console.log('Error fetching existing matching hints:', error);
        toaster.negative('Could not fetch existing matching hints. Trying again!');
      }

      // Only request a new matching hint if it hasn't been requested before
      if (attemptCount === 0 && !hasRequestedMatch) {
        try {
          await reqMatch(projectId, QUESTION_TYPE);
          console.log('New Matching Hint requested successfully.');
          toaster.info('New Matching Hint requested successfully!', {
            autoHideDuration: 5000
          });
        } catch (error) {
          console.log('Error requesting matching hint:', error);
          toaster.negative('Failed to request a matching hint.');
        }
        setHasRequestedMatch(true);
      } else {
        // Implement backoff algorithm for retrying fetchHints
        const delay = Math.pow(2, attemptCount) * 1000;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      attemptCount++;
    }
    toaster.negative('All attempts to fetch cached matching hints and request a new matching hint from carlos have failed.');
    return [];
  };
  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingHints(true); // start loading
      try {
        const data = await fetchHints(matchCtx.matchHintModal.projectId);
        setHints(data);
      } catch (error) {
        console.log('Error in fetching hints:', error);
      } finally {
        setIsLoadingHints(false); // end loading
      }
    };
    fetchData();
  }, [getHints, reqMatch]);
  return <Card title={title}>
      {isLoadingHints ? <AskingCarlosSpinner /> : <>
          <StyledBody>
            {hints[activeMatchingHint]?.answer || hints[0]?.answer}{' '}
          </StyledBody>
          <div className={css({
        display: 'flex',
        justifyContent: 'space-between'
      })}>
            <Button kind="primary" onClick={() => setActiveMatchingHint(prev => prev + 1)} disabled={activeMatchingHint === hints.length - 1}>
              <ArrowLeftIcon />
            </Button>
            <FeedbackButtons />
            <Button kind="primary" onClick={() => setActiveMatchingHint(prev => prev - 1)} disabled={activeMatchingHint === 0}>
              <ArrowRightIcon />
            </Button>
          </div>
        </>}
    </Card>;
}
export default MatchingCard;